module.exports = __webpack_public_path__ + "static/media/ShuroChi_720p.35dcb013.mp4";